import { Injectable } from '@angular/core';
import { CurrencyRateApiService } from '@cms/apis';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { exhaustMap, map } from 'rxjs';
import { CurrencyRateAction } from '../actions';

@Injectable()
export class CurrencyRateEffect {
  loadItem$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(CurrencyRateAction.loadItem),
      exhaustMap(action => {
        return this._apiService.get(action.id).pipe(map(item => CurrencyRateAction.loadItemSuccess({ item })));
      })
    );
  });
  constructor(private _apiService: CurrencyRateApiService, private _actions$: Actions, private _store: Store) {}
}
